module.exports = __webpack_public_path__ + "img/31.e31d8c90.png";